export const L10N = {
  LABEL_PAY_WITH_CARD: { id: 'core.label.pay_with_card' },
};
